import { Component, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AlertMessageService, LoadingService } from "@serpro/ngx-suite-rfb";
import { AtoService } from "src/app/shared/services/ato.service";
import { VISAO_MULTIVIGENTE, VISAO_ORIGINAL, VISAO_RELACIONAL, VISAO_VIGENTE, VISOES_TELA, Visao } from "src/app/shared/model/visao.model";
import { Anotacao } from "src/app/shared/model/anotacao.model";
import { VisaoAto } from "src/app/shared/model/visao-ato.model";
import { DatePipe, Location } from "@angular/common";
import { appRoute } from "src/app/shared/consts/app-routes";
import { DataUtil } from "src/app/shared/util/data.util";
import { VisaoRelacional } from "src/app/shared/model/visao-relacional.model";
import { AuthService } from "src/app/auth/auth.service";
import { CONSULTA_ADMIN, CONSULTA_EXTERNA, CONSULTA_INTERNA, TipoConsulta } from "src/app/shared/model/tipo-consulta.model";
import { AmbienteService } from "src/app/shared/services/ambiente.service";
import { Ambiente } from "src/app/shared/model/ambiente.model";

@Component({
    selector: 'app-visualizar-ato',
    templateUrl: './visualizar-ato.component.html',
    styleUrls: ['./visualizar-ato.component.css', './contraste.css', '../../../../../src/app/shared/css/contraste.css']
})
export class VisualizarAtoComponent implements OnInit {

    @Output() visaoAtoEmitter = new EventEmitter<VisaoAto>();
    @Input() exibirDatasVigencia = false;

    urlFuncionalidade = appRoute.ato.visualizarAto;

    ambiente: Ambiente;

    idAto: number;
    visaoAto: VisaoAto;
    anotacoes: Anotacao[];
    dataSelecionada: Date;
    minDate: Date;
    maxDate: Date;

    visaoSelecionada: Visao;
    visoes = VISOES_TELA;
    visaoRelacional = VISAO_RELACIONAL;
    exibirTela = false;
    exibirVisao = false;
    exibirRetificacaoEpigrafe = false;

    parametrosPagina = '';
    tipoConsulta: TipoConsulta = CONSULTA_ADMIN;

    exibirDataVigenciaHabilitado = false;
    exibicaoPorData = false;
    habilitaConsultar = false;
    dia: string;
    mes: string;
    ano: string;
    data: string;

    // Visualização Sequencial
    exibirLinksVisualizacaoSequencial = false;
    listaVisualizacaoSequencial: number[] = [];
    listaVisualizacaoSequencialStrBase64: string;
    idAtoAnterior = 0;
    idAtoProximo = 0;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        private atoService: AtoService,
        private alertMessageService: AlertMessageService,
        private authService: AuthService,
        private loadingService: LoadingService,
        private readonly ambienteService: AmbienteService
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe(() => {
            const map = this.route.snapshot.paramMap;
            const novo = map.keys.map(key => map.get(key)).join(',');
            if (this.parametrosPagina !== novo) {
                this.parametrosPagina = novo;
                this.iniciar();
            }
        });

        this.ambienteService.getAmbiente().subscribe({
            next: (ambiente: Ambiente) => {
                this.ambiente = ambiente;
            },
            error: () => null
        });
    }

    iniciar(): void {

        this.exibirTela = false;
        this.alertMessageService.dismissAll();
        let parametros: ParametrosUrl;

        try {
            parametros = new ParametrosUrl(this.route.snapshot.paramMap);
        } catch (error) {
            this.alertMessageService.error(error as string);
            return;
        }
        
        // Definir origem
        const routerData = this.route.snapshot.routeConfig?.data;
        if (routerData) {

            this.definirTipoConsulta(routerData);

            this.urlFuncionalidade = this.getBaseUrl();
        }

        // Caso a origem seja do Gerir Atos, deve-se verificar se o usuário está autenticado
        if (this.tipoConsulta.isConsultaAdmin() && !this.authService.isAuthenticated()) {
            console.log("Usuário não autenticado. Sendo redirecionado para a página de login...");
            this.alertMessageService.error("Proibido!", "Você não tem permissão para executar essa transação.");
            return;
        }

        this.idAto = parametros.idAto;
        this.visaoSelecionada = parametros.visao;

        if (parametros.data) {
            this.dataSelecionada = parametros.date;
            this.buscarPorIdNaData(parametros.data);
        } else {
            this.buscarPorIdNaVisao(this.visaoSelecionada);
        }

        this.buscarListaParaVisualizacaoSequencial(parametros.vs);

        const url = this.router.url;
        const indexOfVS = url.indexOf('/vs/');
        if (indexOfVS > 0) {
            this.location.replaceState(url.substring(0, indexOfVS));
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private definirTipoConsulta(routerData: any) {

        if (routerData['gerirAto']) {
            this.tipoConsulta = CONSULTA_ADMIN;
            return;
        }

        if (routerData['consultaInterna']) {
            this.tipoConsulta = CONSULTA_INTERNA;
            return;
        } 
        
        if (routerData['consultaExterna']) {
            this.tipoConsulta = CONSULTA_EXTERNA;
        }
    }

    buscarListaParaVisualizacaoSequencial(listaStrBase64: string) {

        if (listaStrBase64) {
            const listaStr = atob(listaStrBase64);
            const lista = listaStr.split(',').map(num => parseInt(num, 10));

            if (lista && lista.length > 0) {

                const indiceAtoAtual = lista.indexOf(this.idAto);
                if (indiceAtoAtual === -1) {
                    return;
                }
    
                this.listaVisualizacaoSequencialStrBase64 = listaStrBase64;
                this.exibirLinksVisualizacaoSequencial = true;
                this.listaVisualizacaoSequencial = lista;
    
                this.idAtoAnterior = indiceAtoAtual > 0 ? this.listaVisualizacaoSequencial[indiceAtoAtual - 1] : 0;
                this.idAtoProximo = indiceAtoAtual < this.listaVisualizacaoSequencial.length - 1 ? this.listaVisualizacaoSequencial[indiceAtoAtual + 1] : 0;
            }
        }
    }

    getContador(): string {
        if (this.listaVisualizacaoSequencial && this.listaVisualizacaoSequencial.length > 0) {
            const total = this.listaVisualizacaoSequencial.length;
            const atual = this.listaVisualizacaoSequencial.indexOf(this.idAto) + 1;
            return atual + "/" + total;
        }
        return "";
    }

    obterTema() {
        if (!this.visaoAto.publicado) {
            return 'tema-vermelho';
        }
        return this.tipoConsulta.isConsultaExterna() ? 'tema-azul': 'tema-verde'
    }

    definirVisoesHabilitadas() {
        // exibirVisoes é um atributo herdado que contém um dígito (1 exibe e 0 não exibe) para cada visão na ordem:
        // Original Multivigente, Vigente e Relacional
        const e = this.visaoAto.exibirVisoes;
        this.visoes = [];
        if (e.charAt(1) == '1' || e == '0000') {
            this.visoes.push(VISAO_MULTIVIGENTE);
        }
        if (e.charAt(2) == '1') {
            this.visoes.push(VISAO_VIGENTE);
        }
        if (e.charAt(0) == '1') {
            this.visoes.push(VISAO_ORIGINAL);
        }
        if (e.charAt(3) == '1') {
            this.visoes.push(VISAO_RELACIONAL);
        }
    }

    definirBotaoExibirDataInicioHabilitado() {
        this.exibirDataVigenciaHabilitado = 
            this.visaoAto.ancorasNoAto.find(a => a.dataInicioVigencia && a.exibirDataInicioVigencia && !a.ehAgendamento
            ) != undefined
        ||
            this.visaoAto.ementas.find(e =>
                e.ancorasOrigem.find(a => a.dataInicioVigencia && a.exibirDataInicioVigencia && !a.ehAgendamento)
            ) != undefined
        ||
            this.visaoAto.ementas.find(e =>
                e.ancorasDestino.find(a => a.dataInicioVigencia && a.exibirDataInicioVigencia && !a.ehAgendamento)
            ) != undefined
        ||
            this.visaoAto.outrosSegmentos.find(e =>
                e.ancorasOrigem.find(a => a.dataInicioVigencia && a.exibirDataInicioVigencia && !a.ehAgendamento)
            ) != undefined
        ||
            this.visaoAto.outrosSegmentos.find(e =>
                e.ancorasDestino.find(a => a.dataInicioVigencia && a.exibirDataInicioVigencia && !a.ehAgendamento)
            ) != undefined;
    }

    getClassBotaoLateralExibirDataInicio() {
        if (!this.exibirDataVigenciaHabilitado) {
            return 'desabilitado';
        }
        if (this.exibirDatasVigencia) {
            return 'selecionado';
        }
        return null;
    }

    getTitleBotaoLateralExibirDataInicio() {
        const title = "Exibir/ocultar as datas de início de vigência das anotações.";
        if (this.exibirDataVigenciaHabilitado) {
            return title;
        }
        return title + " Esta funcionalidade não está habilitada para este ato.";
    }

    clickBotaoLateralExibirDataInicio() {
        if (this.exibirDataVigenciaHabilitado) {
            this.exibirDatasVigencia = !this.exibirDatasVigencia;
        }
    }

    getClassBotaoLateralConsultarPorData() {
        if (!this.visaoAto.integro || this.visaoAto.exibirVisoes.charAt(1) == '0') {
            // Se o ato não estiver integro ou a visão multivigente não estiver disponível
            return 'desabilitado';
        }
        if (this.habilitaConsultar || this.exibicaoPorData) {
            return 'selecionado';
        }
        return null;
    }
    getTitleBotaoLateralConsultarPorData() {
        const title = "Consultar a versão do ato em uma data específica.";
        if (this.visaoAto.integro && this.visaoAto.exibirVisoes.charAt(1) == '1') {
            return title;
        }
        return title + " Esta funcionalidade não está habilitada para este ato.";
    }

    clickBotaoLateralConsultarPorData() {
        if (this.visaoAto.integro && this.visaoAto.exibirVisoes.charAt(1) == '1') {
            this.habilitaConsultar = !this.habilitaConsultar;
        }
    }

    definirPeriodoSelecaoVisaoPorData() {
        const [year, month, day] = this.visaoAto.dataPublicacao.split('-');
        this.minDate = new Date(+year, +month - 1, +day);
        this.maxDate = new Date();
    }

    private getBaseUrl(): string {

        if (this.tipoConsulta.isConsultaExterna()) {
            return `${appRoute.consulta.externa}`;
        }
        if (this.tipoConsulta.isConsultaInterna()) {
            return `${appRoute.consulta.interna}`;
        }
        return `${appRoute.ato.visualizarAto}`;
    }

    mudarVisao(visao: Visao) {
        this.router.navigate([this.getBaseUrl() + `/${this.idAto}/visao/` + visao?.textoParaUrl + this.obterHashParaUrl()], { replaceUrl: true });
    }

    clickBuscarPorData() {
        this.habilitaConsultar = false;
        const datePipe = new DatePipe("en-US");
        const dataStr = datePipe.transform(this.dataSelecionada, 'yyyy/MM/dd');
        if (dataStr) {
            if (dataStr == datePipe.transform(new Date(), 'yyyy/MM/dd')) {
                this.router.navigate([this.getBaseUrl() + `/${this.idAto}/visao/multivigente` + this.obterHashParaUrl()], { replaceUrl: true });
            } else {
                this.router.navigate([this.getBaseUrl() + `/${this.idAto}/data/` + dataStr + this.obterHashParaUrl()], { replaceUrl: true });
            }
        }
    }

    buscarPorIdNaVisao(visao: Visao) {
        this.habilitaConsultar = false;
        if (visao.isRelacional()) {
            this.buscarVisaoRelacionalDoAto();
        } else {
            this.buscarPorIdNaVisaoTexto(visao);
        }
    }

    /**
     * Verifica, dependendo da origem, se o ato pode ser visualizado.
     */
    private atoPodeSerVisualizado(visao: VisaoAto): boolean {

        // Consulta Interna: são visualizados apenas atos com "liberado pela consulta" =  sim
        if (this.tipoConsulta.isConsultaInterna() && !visao.publicado) {
            this.alertMessageService.error('Ato não encontrado.');
            console.log("[Consulta Interna] retorno.publicado (liberado pela consulta) = ", visao.publicado);
            this.idAto = 0;
            this.loadingService.hide();
            this.exibirLinksVisualizacaoSequencial = false;
            return false;
        }

        // Consulta Externa: são visualizados apenas atos com "liberado pela consulta" =  sim e "Internet" = sim
        if (this.tipoConsulta.isConsultaExterna() && (!visao.publicado || !visao.internet)) {
            this.alertMessageService.error('Ato não encontrado.');
            console.log("[Consulta Externa] retorno.internet = ", visao.internet);
            console.log("[Consulta Externa] retorno.publicado (liberado pela consulta) = ", visao.publicado);
            this.idAto = 0;
            this.loadingService.hide();
            this.exibirLinksVisualizacaoSequencial = false;
            return false;
        }

        return true;
    }

    buscarPorIdNaVisaoTexto(visao: Visao) {

        this.loadingService.show();
        this.atoService.buscarPorIdNaVisao(this.idAto, visao, this.tipoConsulta).subscribe({
            next: retorno => {
                
                if (retorno == null) {
                    this.alertMessageService.error('Ato não encontrado.');
                    this.idAto = 0;
                    this.loadingService.hide();
                    return;
                }
                
                if (!this.atoPodeSerVisualizado(retorno)) {
                    return;
                }

                this.visaoAto = retorno;
                this.definirVisoesHabilitadas();
                if (visao.textoParaUrl != this.visaoAto.visao) {
                    const v = Visao.getByName(this.visaoAto.visao);
                    if (v != null) {
                        this.visaoSelecionada = v;
                        if (v.isOriginalConjunta() || v.isOriginalExclusiva()) {
                            this.visaoSelecionada = VISAO_ORIGINAL;
                        }
                    }
                }
                this.definirPeriodoSelecaoVisaoPorData();
                this.definirBotaoExibirDataInicioHabilitado();
                document.title = this.visaoAto.epigrafeUrl;
                this.loadingService.hide();
                this.exibirVisao = true;
                this.exibirTela = true;
                this.visaoAtoEmitter.emit({...this.visaoAto, visao: this.visaoSelecionada.textoExibido});
            },
            error: (e) => {
                if (e?.error?.message?.indexOf('A visão solicitada não está disponível para este ato. Consulte a visão ') == 0) {
                    const visao = e.error.message.substr(71);
                    const i = ['multivigente','vigente','original','relacional'].indexOf(visao);
                    const novaVisao = [VISAO_MULTIVIGENTE, VISAO_VIGENTE, VISAO_ORIGINAL, VISAO_RELACIONAL][i]
                    this.mudarVisao(novaVisao);
                    setTimeout(() => {
                        this.loadingService.hide();
                    }, 10);
                } else {
                    this.loadingService.hide();
                }
            }
        })
    }

    buscarPorIdNaData(data: string) {
        this.habilitaConsultar = false;
        this.loadingService.show();
        this.atoService.buscarPorIdNaData(this.idAto, data, this.tipoConsulta).subscribe({
            next: retorno => {

                if (retorno == null) {
                    this.alertMessageService.error('Ato não encontrado.');
                    this.idAto = 0;
                    this.loadingService.hide();
                    return;
                }

                if (!this.atoPodeSerVisualizado(retorno)) {
                    return;
                }

                this.ano = data.substring(0,4);
                this.mes = data.substring(5,7);
                this.dia = data.substring(8,10);
                if (this.dia.length == 1) {
                    this.dia = '0' + this.dia;
                }
                this.data = this.dia + '/' + this.mes + '/' + this.ano;
                this.mes = ['JAN','FEV','MAR','ABR','MAI','JUN','JUL','AGO','SET','OUT','NOV','DEZ'][parseInt(this.mes)-1];
                this.exibicaoPorData = true;
                this.visaoAto = retorno;
                this.definirVisoesHabilitadas();
                this.definirPeriodoSelecaoVisaoPorData();
                this.exibirVisao = true;
                this.exibirTela = true;
                this.definirBotaoExibirDataInicioHabilitado();
                this.loadingService.hide();
                this.visaoAtoEmitter.emit({...this.visaoAto, visao: this.visaoSelecionada.textoExibido});
            },
            error: () => this.loadingService.hide()
        })
    }

    atoVisaoRelacional: VisaoRelacional;

    buscarVisaoRelacionalDoAto() {
        this.loadingService.show();
        this.atoService.buscarVisaoRelacionalDoAto(this.idAto, this.tipoConsulta).subscribe({
            next: visaoRelacional => {

                if (visaoRelacional == null) {
                    this.alertMessageService.error('Ato não encontrado.');
                    this.idAto = 0;
                    this.loadingService.hide();
                    return;
                }

                if (!this.atoPodeSerVisualizado(visaoRelacional.visaoAto)) {
                    return;
                }

                this.visaoAto = visaoRelacional.visaoAto;
                this.atoVisaoRelacional = visaoRelacional;
                this.definirVisoesHabilitadas();
                document.title = this.visaoAto.epigrafeUrl;
                this.loadingService.hide();
                if (this.loadingService.isLoading()) {
                    // se há duas chamadas, é necessário fechar duas vezes - exemplo: buscar visão não habilitada
                    this.loadingService.hide();
                }
                this.exibirVisao = true;
                this.exibirTela = true;
                this.visaoAtoEmitter.emit({...this.visaoAto, visao: this.visaoSelecionada.textoExibido});
            },
            error: () => this.loadingService.hide()
        })
    }

    visualizarAtoAnterior() {
        if (this.idAtoAnterior > 0) {
            this.router.navigate([this.getBaseUrl() + `/${this.idAtoAnterior}` + this.obterHashParaUrl()], { replaceUrl: true });
        }
    }

    visualizarAtoPosterior() {
        if (this.idAtoProximo > 0) {
            this.router.navigate([this.getBaseUrl() + `/${this.idAtoProximo}` + this.obterHashParaUrl()], { replaceUrl: true });
        }
    }

    getUrlPaginaInicial() {  
        if (this.ambiente) {
            if (this.ambiente.ambiente === 'loc') {
                return `#${appRoute.ato.gerirAtos}`;
            }
            if (this.tipoConsulta.isConsultaExterna()) {
                return `${this.ambiente.urlHome}/sijut2consulta`;
            } else if (this.tipoConsulta.isConsultaInterna()) {
                if (this.ambiente.ambiente === 'pro') {
                    return `http://normasintranet.receita.fazenda/sijut2consulta-interno`;
                } else {
                    return `${this.ambiente.urlHome}/sijut2consulta-interno`
                }
            }
            return `#${appRoute.ato.gerirAtos}`;
        }
        return '#/';
    }

    @HostListener('window:keydown', ['$event'])
    handleEventoTeclado(evento: KeyboardEvent) {        
        if (evento.ctrlKey && evento.key === 'p') {
            this.imprimir();
        }
    }

    imprimir() {
        if (this.dataSelecionada) {
            const datePipe = new DatePipe("en-US");
            const dataStr = datePipe.transform(this.dataSelecionada, 'yyyy/MM/dd');
            const url = `#/${this.getBaseUrl()}/imprimir/${this.idAto}/data/${dataStr}`;
            window.open(url, '_blank');
        } else {
            const url = `#/${this.getBaseUrl()}/imprimir/${this.idAto}/visao/${this.visaoSelecionada.textoParaUrl}`;
            window.open(url, '_blank');
        }
    }

    private obterHashParaUrl(): string {
        if (this.listaVisualizacaoSequencialStrBase64) {
            return "/vs/" + this.listaVisualizacaoSequencialStrBase64;
        }
        return '';
    }
}

export class ParametrosUrl {

    idAto: number;
    visao: Visao;
    data: string; // yyyy-MM-dd
    date: Date;
    vs: string;
    tipo: string;
    token: string;

    constructor (paramMap?: ParamMap) {

        if (!paramMap) {
            return;
        }

        const id = paramMap.get('id');
        const visao = paramMap.get('visao');
        const ano = paramMap.get('ano');
        const mes = paramMap.get('mes');
        const dia = paramMap.get('dia');
        const vs = paramMap.get('vs');
        const tipo = paramMap.get('tipo');
        const token = paramMap.get('token');

        this.checkIf(id == null, 'Não foi informado o id do ato na url.');
        this.checkIf(!/^\d+$/.test(id ?? ''), 'Foi informado um id inválido para o id do ato.');
        this.idAto = parseInt(id ?? '');

        if (visao != null) {
            const i = ['multivigente','vigente','original','relacional'].indexOf(visao);
            this.checkIf(i < 0, 'A visão informada na url é inválida.');
            this.visao = [VISAO_MULTIVIGENTE, VISAO_VIGENTE, VISAO_ORIGINAL, VISAO_RELACIONAL][i]
        }
        if (ano || mes || dia) {
            this.checkIf(ano != null && !/^\d{4}$/.test(ano), 'Foi informado um valor inválido para o ano na url.');
            this.checkIf(mes != null && !/^\d{2}$/.test(mes), 'Foi informado um valor inválido para o mês na url.');
            this.checkIf(dia != null && !/^\d{2}$/.test(dia), 'Foi informado um valor inválido para o dia na url.');
            const str = dia + '/' + mes + '/' + ano;
            const asDate = DataUtil.parseStrToDate(str);
            this.checkIf(asDate == null, 'Foi informada uma data inválida na url.');
            this.checkIf(asDate != null && (DataUtil.dateToStr(asDate) != str), 'Foi informada uma data inválida na url.');
            this.data = ano + '-' + mes + '-' + dia;
            if (asDate) {
                this.date = asDate;
            }
            this.visao = VISAO_MULTIVIGENTE;
        }
        if (this.visao == null) {
            this.visao = VISAO_MULTIVIGENTE;
        }
        if (vs != null) {
            this.vs = vs;
        }
        if (token != null) {
            this.token = token;
        }
        if (tipo != null) {
            this.tipo = tipo;
        }
    }

    checkIf(condicao: boolean, mensagem: string) {
        if (condicao) {
            throw mensagem;
        }
    }
}
